export const DEFAULT_ROW_HEIGHT = 32;
export const DEFAULT_INDENT = 24;
export const DEFAULT_HEIGHT = 500;
